import { ItemDetailDto } from "./item-details-dto.model";

export class OrderOfferInputDto {
    promotionCode = '';
    itemDetails: ItemDetailDto[] = [];
}